interface ErrorResponse {
  error?: string;
  message?: string;
}

export const extractErrorMessage = (errorData: string | ErrorResponse | null): string => {
  if (typeof errorData === "string") return errorData;
  if (typeof errorData === "object" && errorData) {
    return errorData.error || errorData.message || JSON.stringify(errorData);
  }
  return "An error occurred.";
};

export const convertToUserFriendlyMessage = (message: string): string => {
  const messageMap: Record<string, string> = {
    "No fields with data found":
      "No fields with data found. Please make sure your columns are populated."
  };
  return messageMap[message] || message;
};
